$(document).ready(function () {
    newsletterSignup();
});

// Newsletter singup form
function newsletterSignup() {
    $('#newsletter-form').on('submit', function (e) {
        e.preventDefault();

        let name = $('input[name="name"]', $(this)).val();
        let mail = $('input[name="mail"]', $(this)).val();

        $('.formElement').removeClass('error');
        $('#newsletter-form-header').find(".alert").remove();

        $.ajax({
            type: 'POST',
            url: 'ajax/mailchimp',
            data: { name: name, mail: mail }
        }).done(function (feedback) {
            let alertClass;
            if (feedback.hasOwnProperty('error') && feedback.error === 1) {
                alertClass = 'danger';
            } else {
                $('#newsletter-form').hide();
                alertClass = 'success';
            }
            $('#newsletter-form-header').append('<div class="alert mb-2 alert-' + alertClass + ' alert-dismissible fade show" role="alert">' + feedback.message + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
        });
    });
}
